/**
 * Privacy Policy — static legal text.
 * Content from app/templates/legal/privacy.html, last updated December 2, 2025.
 */
import './auth.css'

export default function Privacy() {
  return (
    <div className="auth-page" style={{ alignItems: 'flex-start' }}>
      <div className="legal-page">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: December 2, 2025</p>

        <p>This privacy policy ("Policy") describes how Priori Sports, Inc. ("Priori," "we," "us," or "our") collects, uses, shares, and protects the personal information of users of our web application and API services (the "Services").</p>

        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly, such as your name, email address, organization, and account credentials when you register for or use our Services. We also collect usage data including pages visited, features used, and performance metrics.</p>
        <p>When you upload video or tracking data for analysis, we process that data to provide our analytical services. This data may include match footage, player tracking coordinates, and game metadata.</p>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to provide, maintain, and improve our Services; to communicate with you about your account and our products; to personalize your experience; and to develop new features and services. We may also use aggregated, anonymized data for research and product development.</p>

        <h2>3. AI and Analytical Products</h2>
        <p>Our Services include AI-powered analytical tools that process video and tracking data. The outputs of these tools — including tactical analyses, performance metrics, and visual overlays — are generated programmatically and should be reviewed by qualified analysts before being relied upon for competitive decisions.</p>

        <h2>4. Data Sharing</h2>
        <p>We do not sell your personal information. We may share information with service providers who assist in operating our platform (cloud hosting, email delivery, video processing), with your organization's administrators, or as required by law. Third-party service providers are contractually obligated to protect your data.</p>

        <h2>5. Data Retention</h2>
        <p>We retain your account information for as long as your account is active or as needed to provide the Services. Video and tracking data are retained according to your organization's data management preferences. You may request deletion of your data by contacting us.</p>

        <h2>6. Security</h2>
        <p>We implement industry-standard security measures to protect your information, including encryption in transit and at rest, access controls, and regular security assessments. However, no method of electronic storage is completely secure, and we cannot guarantee absolute security.</p>

        <h2>7. Your Rights</h2>
        <p>Depending on your location, you may have the right to access, correct, delete, or port your personal information. You may also have the right to opt out of certain data processing activities. To exercise these rights, contact us at <a href="mailto:contact@priorisports.com">contact@priorisports.com</a>.</p>

        <h2>8. Do Not Track</h2>
        <p>Our Services do not currently respond to "Do Not Track" browser signals. We use analytics tools to understand how our Services are used and to improve them.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Policy from time to time. We will notify you of material changes by posting the updated Policy on our website with a new "Last updated" date. Your continued use of the Services after such changes constitutes acceptance of the updated Policy.</p>

        <h2>10. Contact</h2>
        <p>For questions about this Privacy Policy or our data practices, contact us at <a href="mailto:contact@priorisports.com">contact@priorisports.com</a>.</p>

        <div className="auth-links" style={{ marginTop: 32 }}>
          <a href="/login">Back to sign in</a>
        </div>
      </div>
    </div>
  )
}
